import { createWebHashHistory, createRouter } from "vue-router";
import Home from "@/pages/Home.vue";

import BaseLayout from "@/pages/layouts/BaseLayout.vue";
import LoginLayout from "@/pages/layouts/LoginLayout.vue";

import Login from "@/pages/auth/Login.vue";
import Register from "@/pages/auth/Register.vue";

import FetishForum from "@/pages/fetish/Forum.vue";
import FetishPost from "@/pages/fetish/Post.vue";
import FetishNew from "@/pages/fetish/New.vue";
import NationalityForum from "@/pages/nationality/Forum.vue";

const base = process.env.VUE_APP_BASEROUTE;

const routes = [
  {
    path: "/forum",
    name: "Forum",
    component: Home,
  },
  {
    path: "/bruger",
    component: LoginLayout,
    children: [
      {
        path: "login",
        name: "login",
        component: Login,
      },
      {
        path: "register",
        name: "legister",
        component: Register,
      },
    ],
  },
  {
    path: "/igler",
    component: BaseLayout,
    children: [
      {
        path: "",
        name: "igler",
        component: FetishForum,
      },
      {
        path: "post/:id",
        name: "post",
        component: FetishPost,
      },
      {
        path: "ny",
        name: "ny",
        component: FetishNew,
      },
    ],
  },
  {
    path: "/danmark",
    component: BaseLayout,
    children: [
      {
        path: "",
        name: "danmark",
        component: NationalityForum,
      },
    ],
  },
  { path: "/:pathMatch(.*)*", name: "NotFound", redirect: "/forum" },
];

const router = createRouter({
  history: createWebHashHistory(),
  base,
  routes,
});

export default router;
